import { ShortcutBinding } from '../../../proxy/models/shortcut-binding';

export enum ShortcutTarget {
  Help = 'help',
  Navigation = 'navigation',
}

export const PAGE_SHORTCUTS: Record<ShortcutTarget, ShortcutBinding> = {
  [ShortcutTarget.Help]: {
    id: ShortcutTarget.Help,
    key: 'h',
    modifiers: ['ctrl', 'meta'],
    description: '',
    action: 'custom',
    target: ''
  },
  [ShortcutTarget.Navigation]: {
    id: ShortcutTarget.Navigation,
    key: 'a',
    modifiers: ['ctrl', 'meta'],
    description: '',
    action: 'custom',
    target: ''
  },
};

export function getShortcutTarget(shortcutTarget: ShortcutTarget): string {
  const isMac = navigator?.platform?.toUpperCase().includes('MAC');

  return (isMac ? '⌘' : 'Ctrl') + ' K → ' + PAGE_SHORTCUTS[shortcutTarget].key.toUpperCase();
}
